export const BYTE = 1;
export const KB = BYTE * 1024;
export const MB = KB * 1024;
export const GB = MB * 1024;
